module.exports = __webpack_public_path__ + "dm.svg?10dcdf52a243d92a93d49633f5b63786";